(() => {

  const isMobile = () => window.matchMedia("(max-width: 767px)").matches;

  function initDots(section) {
    if (!isMobile()) return;

    const rail = section.querySelector(".image-rail");
    if (!rail || rail.dataset.dotsReady === "1") return;

    const slides = Array.from(rail.querySelectorAll(":scope > .image-block"));
    if (slides.length <= 1) return;

    const dots = document.createElement("div");
    dots.className = "spoils-rail-dots";

    const buttons = slides.map((_, index) => {
      const dot = document.createElement("button");
      dot.className = "spoils-rail-dot";
      dot.type = "button";

      dot.addEventListener("click", () => {
        const width = rail.clientWidth;
        rail.scrollTo({ left: index * width, behavior: "smooth" });
      });

      dots.appendChild(dot);
      return dot;
    });

    rail.insertAdjacentElement("afterend", dots);

    const setActive = () => {
      const width = rail.clientWidth || 1;
      const current = Math.round(rail.scrollLeft / width);
      buttons.forEach((b, i) => {
        b.classList.toggle("is-active", i === current);
      });
    };

    rail.addEventListener("scroll", () => {
      requestAnimationFrame(setActive);
    });

    setActive();
    rail.dataset.dotsReady = "1";
  }

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("section.shopify-section--main-product-catalog, section.spoils-pdp-catalog")
      .forEach(initDots);
  });

})();
